/** Compact original line drawings shared by character and hand controls. */
export function carryIcon(kind: "character" | "pocket" | "hand" | "flashlight" | "battery" | "jeans"): string {
  const paths = {
    character: '<circle cx="16" cy="6" r="3"/><path d="m9 12-3 9m17-9 3 9M10 11h12l-2 10 2 9h-5l-1-8-1 8h-5l2-9Z"/>',
    pocket: '<path d="M6 6h20v15l-10 7-10-7Z"/><path d="M9 10h14"/>',
    hand: '<path d="M9 18V9a2 2 0 0 1 4 0v7-11a2 2 0 0 1 4 0v11-9a2 2 0 0 1 4 0v10-6a2 2 0 0 1 4 0v10c0 7-3 9-8 9-4 0-7-3-9-6l-4-6c-2-3 1-5 3-2Z"/>',
    flashlight: '<path d="m13 13 10 10-7 7L6 20Zm-2-2 5-9 14 14-9 5ZM4 5 1 2m8 0V0M2 10H0"/><path d="m11 21 4 4m-1-7 4 4"/>',
    battery: '<path d="M11 5V2h10v3M9 5h14v25H9Z"/><path d="M12 11h8m-4-4v8m-4 10h8"/>',
    jeans: '<path d="M6 3h20l3 27H18l-2-17-2 17H3ZM6 8h20M8 8l-2 6m18-6 2 6M20 8v4h4M16 3v9"/>',
  };
  return `<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true">${paths[kind]}</svg>`;
}
